(() => {
  const previewSelector = 'a[href*="view=font-preview"]';
  const updateLink = (link) => {
    const info = link.closest('product-info');
    if (!info) return;
    const variant = info.querySelector('form[action*="/cart/add"] input[name="id"]')?.value;
    const quantity = info.querySelector('input[name="quantity"]')?.value;
    const url = new URL(link.href, location.origin);
    if (variant) url.searchParams.set('variant', variant);
    if (quantity && /^\d+$/.test(quantity) && Number(quantity) > 0) url.searchParams.set('quantity', quantity);
    const theme = new URL(location.href).searchParams.get('preview_theme_id');
    if (theme) url.searchParams.set('preview_theme_id', theme);
    link.href = url.href;
  };
  document.addEventListener('click', (event) => {
    const link = event.target.closest(previewSelector);
    if (link) updateLink(link);
  }, true);
  document.addEventListener('focusin', (event) => {
    if (event.target.matches(previewSelector)) updateLink(event.target);
  });
  document.querySelectorAll('akerland-name-preview').forEach((preview) => {
    const color = preview.querySelector('[data-color]');
    if (!color) return;
    const id = color.id + '-hex';
    const label = document.createElement('label');
    label.htmlFor = id;
    label.textContent = color.dataset.hexLabel;
    const hex = document.createElement('input');
    hex.id = id;
    hex.type = 'text';
    hex.className = 'ak-color-code';
    hex.value = color.value;
    hex.pattern = '#[0-9A-Fa-f]{6}';
    hex.maxLength = 7;
    hex.spellcheck = false;
    color.after(label, hex);
    hex.addEventListener('input', () => {
      if (/^#[0-9a-f]{6}$/i.test(hex.value)) {
        color.value = hex.value;
        color.dispatchEvent(new Event('input', {bubbles:true}));
      }
    });
    color.addEventListener('input', () => {hex.value = color.value;});
  });
})();
